import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import ChipFieldInput from '../../../Global/Inputs/ChipField';
import _get from 'lodash/get';
export default class ReferenceTextField extends Component {
  static propTypes = {
    fieldNumber: PropTypes.number.isRequired,
    fieldOptions: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    values: PropTypes.array
  };
  _handleChange = (form, { target: { name, value } }) => {
    const { errors } = form;
    const error = _get(errors, name, '');
    if (error && value.length > 0) {
      // so i revalidate here because validation works a little funny for these types of fields
      form.setFieldError(name, null);
    }
    form.setFieldValue(name, value);
  };
  render() {
    const { fieldOptions, fieldNumber, values } = this.props;

    return (
      <Field
        name={`references[${fieldNumber}].values`}
        render={({ field, form }) => (
          <ChipFieldInput
            label={fieldOptions.label}
            field={field}
            form={form}
            onChange={event => {
              this._handleChange(form, event);
            }}
            value={values}
          />
        )}
      />
    );
  }
}
